import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrackingService } from 'app/services/tracking.service';
import { RankingsAnonFormService } from '../../../services/rankings-anon-form.service';
import { User } from 'app/models/User';

declare var hbspt;

type FormState = 'idle' | 'submitting' | 'submitted';

@Component({
  selector: 'app-rankings-anon-form-v2',
  templateUrl: './rankings-anon-form-v2.component.html',
  styleUrls: ['./rankings-anon-form-v2.component.scss']
})
export class RankingsAnonFormV2Component implements OnInit {
  @Input()
  formId = 'd46b4eee-0a77-4016-8462-94b6ee68e061';

  @Input()
  eventName = 'ratings_form_email';

  @Input() formTitle;

  @Output()
  formSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  formReady: EventEmitter<boolean> = new EventEmitter<boolean>();

  showAnonEmailUnlockForm = false;
  state: FormState = 'idle';

  constructor(
    private _tracking: TrackingService,
    private _service: RankingsAnonFormService,
    private _userService: User
  ) {}

  ngOnInit(): void {
    hbspt.forms.create({
      region: 'na1',
      portalId: '2364596',
      formId: this.formId,
      target: `.anon-unlock-form`,
      onFormSubmit: $form => {
        this.state = 'submitting';
        const email = $form[0][0].value;
        this._tracking.identify({ email });
        this._tracking.eventTrack(this.eventName, { email });
        this._service.submitForm();
      },
      onFormSubmitted: callback => {
        this.state = 'submitted';
        this.formSubmit.emit(true);
        this.toggleAnonForm(1000);
      },
      onFormReady: $form => {
        this.formReady.emit(true);
        return true;
      }
    });

    this.toggleAnonForm();
  }

  toggleAnonForm(delay = 2000) {
    setTimeout(() => {
      this.showAnonEmailUnlockForm =
        this._userService.isAnonymous() && !this._service.isFormSubmitted();
    }, delay);
  }
}
